import axios from 'axios';
import { sortBy } from 'lodash';
import apiCompetenciasEspecificas from './competencias_especificas';

function urlBaseMaestros(idCurso) {
  return `/lomloe/maestros/${idCurso}`;
}

function optsBase(options) {
  const opts = options || {};
  const defaultParams = {};
  opts.params = Object.assign(defaultParams, opts.params);
  return opts;
}

export function ordenarDefiniciones(definiciones) {
  return sortBy(definiciones, 'orden');
}
/**
 * Dada una lista de definiciones de criterios de varias competencias,
 * las ordena agrupando por competencia y luego por criterio
 * Devuelve un array plano con los criterios ordenados
 */
export function ordenarCriteriosMultiCompetencias(criterios) {
  return sortBy(criterios, ['competencia_especifica_definicion.orden', 'orden']);
}

export default {
  infoAsignatura(idAsignatura, options) {
    const opts = options || {};
    const defaultParams = { asignatura_id: idAsignatura };
    opts.params = Object.assign(defaultParams, opts.params);

    return axios.get('/lomloe/maestros/info_asignatura', opts);
  },
  infoCurso(idCurso, options) {
    return axios.get(`${urlBaseMaestros(idCurso)}/info_curso`, optsBase(options));
  },
  guardarCriterioEvaluacion(idCurso, criterio, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/guardar_criterio_evaluacion`, { criterio }, options);
  },
  eliminarCriterioEvaluacion(idCurso, criterio, options) {
    const data = { criterio };
    return axios.delete(`${urlBaseMaestros(idCurso)}/eliminar_criterio_evaluacion`, { data }, options);
  },
  guardarCompetenciaClave(idCurso, competencia, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/guardar_competencia_clave`, { competencia }, options);
  },
  eliminarCompetenciaClave(idCurso, competencia, options) {
    const data = { competencia };
    return axios.delete(`${urlBaseMaestros(idCurso)}/eliminar_competencia_clave`, { data }, options);
  },
  guardarDescriptorOperativo(idCurso, descriptor, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/guardar_descriptor_operativo`, { descriptor }, options);
  },
  eliminarDescriptorOperativo(idCurso, descriptor, options) {
    const data = { descriptor };
    return axios.delete(`${urlBaseMaestros(idCurso)}/eliminar_descriptor_operativo`, { data }, options);
  },
  guardarCompetenciaEspecificaDescriptor(idCurso, competencia, descriptor, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/guardar_competencia_especifica_descriptor`, { competencia, descriptor }, options);
  },
  eliminarCompetenciaEspecificaDescriptor(
    idCurso, competenciaEspecifica, competenciaEspecificaDescriptor, options,
  ) {
    const data = {
      asignatura_id: competenciaEspecifica.asignatura_id,
      competencia_especifica_id: competenciaEspecifica.id,
      competencia_especifica_descriptor_id: competenciaEspecificaDescriptor.id,
    };
    return axios.delete(`${urlBaseMaestros(idCurso)}/eliminar_competencia_especifica_descriptor`, { data }, options);
  },
  clonarCurso(idCurso, idCursoOrigen, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/clonar_curso`, { origen_curso_id: idCursoOrigen }, options);
  },
  actualizarOrdenCompetenciasClave(idCurso, idsItems, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/actualizar_orden_competencias_clave`, { orden: idsItems }, options);
  },
  actualizarOrdenDescriptores(idCurso, idsItems, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/actualizar_orden_descriptores`, { orden: idsItems }, options);
  },
  actualizarOrdenCriteriosEvaluacion(idCurso, idsItems, options) {
    return axios.post(`${urlBaseMaestros(idCurso)}/actualizar_orden_criterios_evaluacion`, { orden: idsItems }, options);
  },
  competenciasEspecificas: apiCompetenciasEspecificas,
};
